// extracted by mini-css-extract-plugin
export default {"btn":"FavoriteBtn_btn__uZ1Le","btn_active":"FavoriteBtn_btn_active__4zrZx"};